import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { SWRConfig } from 'swr';
import options from '@/service/swrConfig';
import { BrowserRouter, HashRouter, Routes } from 'react-router-dom';
import { getEnv } from '@/env';
import 'animate.css';
import './locales/i18n';

// import VConsole from 'vconsole';

// const vConsole = new VConsole();

import '@/utils/initRem';
import './assets/styles/reset.css';
import 'virtual:uno.css';

const env = getEnv(import.meta.env.MODE);
ReactDOM.createRoot(document.getElementById('root')!).render(
  <SWRConfig value={options}>
    <BrowserRouter basename={env.routerBase}>
      <App />
    </BrowserRouter>
  </SWRConfig>
);
